import {
  DateCell,
  dateTimeFormatter,
  formatNumber,
  formattedCell,
  passthroughFormatter
} from '@dec/shared';
import { type ColDef, type ValueFormatterParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import GridApplication from '@/app/components/grid/gridApplication';
import env from '@/env';

import { JurisdictionCell } from '../../organization/utils/JurisdictionCell';

export const DisbursementPendingTransactionsCard = () => {
  const { t } = useTranslation();

  const colDef: Array<ColDef> = [
    {
      headerName: t('taxpayer-current-account.label.date'),
      field: 'createdDate',
      ...formattedCell(dateTimeFormatter, DateCell)
    },
    {
      headerName: t('config.tin'),
      field: 'tin'
    },
    {
      headerName: t('taxpayers.name'),
      field: 'taxpayerName'
    },
    {
      headerName: t('common.label.jurisdiction'),
      field: 'jurisdiction',
      ...formattedCell(passthroughFormatter, JurisdictionCell)
    },
    {
      headerName: t('currentAccounts.transactionType'),
      field: 'transactionTypeName'
    },
    {
      headerName: t('currentAccounts.credit'),
      field: 'value',
      cellStyle: {
        textAlign: 'right'
      },
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value > 0 ? formatNumber(Math.abs(params.value)) : '';
      }
    },
    {
      headerName: t('currentAccounts.document'),
      field: 'documentNumber',
      // https://github.com/ag-grid/ag-grid/issues/5226
      cellRenderer: function (params: any) {
        // se construye el link y el texto
        let url = '';
        const text: string = params.data.documentNumber;

        if (params.data.taxReturnId) {
          url = `${env.publicUrl}/taxpayer/tax-returns/preview/${params.data.taxReturnId}`;
        }
        if (params.data.taxReturnPaymentId) {
          url =
            `${env.publicUrl}/taxpayer/taxreturn-payment/view?taxReturnId=` +
            params.data.taxReturnId +
            '&paymentId=' +
            params.data.taxReturnPaymentId;
        }

        if (params.data.transactionAdjustmentId) {
          url =
            `${env.publicUrl}/taxpayer/transaction-adjustment/view?id=` +
            params.data.transactionAdjustmentId;
        }

        if (!url) {
          // si no tenemos una url por abrir
          return <span> --- </span>;
        }

        // ahora se devuelve el vinculo
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        );
      }
    }
  ];

  return (
    <>
      <div className="row mt-4 mb-5">
        <div className="col-12">
          <GridApplication url={`/disbursement/pending/transactions`} columnDefs={colDef} />
        </div>
      </div>
    </>
  );
};
